import React /* useState, useEffect, useContext */ from 'react';
/* import t from '../../../../utils/translate'; */
/* import SessionContext from 'api/session/context'; */
import Reputacion from './reputation';
/* import Metrics from './metrics'; */
import { ReportsHome } from '../reports-home';
import { ReportsReputacion } from '../reports-reputacion';
import { ReportsStockBreaksFines } from '../reports-stockbreaksfines';
/* import PopupSeller from 'components/Dialog/PopupSeller'; */

export function DashboardSellers() {
  /* const firstTimeTour = localStorage.getItem('firstTimeTour'); */

  /* const {
    auth: { sellerId },
  } = useContext(SessionContext); */

  /* const [open, setOpen] = useState(false); */

  /* useEffect(() => {
    const sellerLocal = localStorage.getItem('sellerlocalmodalcyber');
    if (sellerLocal !== sellerId) {
      setOpen(true);
    }
  }, [sellerId]); */
  return (
    <>
      <Reputacion />
      <ReportsHome />
      <ReportsReputacion />
      <ReportsStockBreaksFines />
      {/* {firstTimeTour === '1' && <PopupSeller open={open} sellerId={sellerId} setOpen={setOpen} t={t} />} */}
    </>
  );
}
